import { css } from '@emotion/core'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

import { BlogAuthorInfoProps } from '../../../interfaces/blog'
import Block from './../../Block'
import { Link } from './../../Link'

export const BlogAuthorInfo: React.FunctionComponent<BlogAuthorInfoProps> = ({
  author: { name, slug, authorPhoto },
  className,
  textClassName = 'body-1',
  avatarSize = 35,
  cssStyles,
  isImageOnTheRight = false,
}) => {
  return (
    <Link className={className} href={`/blog/author/${slug}/`} css={cssStyles}>
      <Block
        columns={2}
        columnsTemplate={isImageOnTheRight ? `auto ${avatarSize}px` : `${avatarSize}px auto`}
        css={blockStyle}
        columnGap={0.75}
        noBreak
      >
        {!isImageOnTheRight && (
          <GatsbyImage
            image={authorPhoto.gatsbyImageData}
            alt={`airfocus author: ${name}`}
            css={avatarStyle(avatarSize)}
          />
        )}
        <div className={textClassName} css={textContainerStyle}>
          {!isImageOnTheRight && <span className={'black-text'}>By </span>}
          <span className={'blue-gradient-text'}>{name}</span>
        </div>
        {isImageOnTheRight && (
          <GatsbyImage
            image={authorPhoto.gatsbyImageData}
            alt={`airfocus author: ${name}`}
            css={avatarStyle(avatarSize)}
          />
        )}
      </Block>
    </Link>
  )
}

const blockStyle = css`
  width: fit-content;
  margin: 0;

  &:hover {
    .blue-gradient-text {
      opacity: 0.65;
    }
  }
`

const avatarStyle = (avatarSize: number) => css`
  max-width: ${avatarSize}px;
  height: ${avatarSize}px;
  border-radius: 50%;
`

const textContainerStyle = css`
  margin: 0 !important;
`
